module.exports = __webpack_public_path__ + "img/ep-planche-organique.1b6d7ae1.jpg";